import {PodValidation} from './pod-validation.model';

export class SearchPodValidationResult {

  public results: PodValidation[] = [];
  public pendingTotalCount: number;
  public chepReviewTotalCount: number;
  public validatedTotalCount: number;
  public page: number;
  public totalPages: number;
  public pageSize: number;

  static fromDto(s: any): SearchPodValidationResult {
    const search = new SearchPodValidationResult();

    search.results    = s.results.map(r => PodValidation.fromDto(r));
    search.pendingTotalCount = s.pending_total_count;
    search.chepReviewTotalCount = s.chep_review_total_count;
    search.validatedTotalCount = s.validated_total_count;
    search.page       = s.page;
    search.totalPages = s.total_pages;
    search.pageSize   = s.page_size;

    return search;
  }
}
